import { createAsyncThunk } from "@reduxjs/toolkit";
import { AuditDocumentsAPI } from "api/api/auditDocumentsApi/auditDocumentsApi";
import { GetAuditDocumentParams, GetAuditDocumentResponse } from "api/api/auditDocumentsApi/types";
import { AuditTab } from "api/slice/auditDocumentsSlice/types";
import { List } from "api/slice/types";
import axios from "axios";

export const getAuditDocument = createAsyncThunk<
  { tab: AuditTab; data: List<GetAuditDocumentResponse> },
  { tab: AuditTab; params: GetAuditDocumentParams }
>(`documents/getAuditDocument`, async ({ tab, params }, { rejectWithValue }) => {
  try {
    const data = await AuditDocumentsAPI.getAuditDocument(params);
    return { tab, data };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while getting audit document",
        error?.response?.data
      );
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting audit document", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
